import { useMemo, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from 'react-redux';
import { createAppTheme } from './theme';

export default function DynamicThemeProvider({ children }) {
    const company_layout = useSelector((state) => state.company_layout);

    const primary = company_layout?.theme?.primary?.trim() || '#013b70';
    const secondary = company_layout?.theme?.secondary?.trim() || '#26b2b8';
    const warning = company_layout?.theme?.warning?.trim() || '#FFCC00';
    const primaryLight = company_layout?.theme?.primary_light?.trim() || primary;

    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--color-primary', primary);
        root.style.setProperty('--color-primary-light', primaryLight);
        root.style.setProperty('--color-secondary', secondary);
        root.style.setProperty('--color-warning', warning);
        root.style.setProperty('--shadow-card', `0 4px 16px ${primary}14`);
        root.style.setProperty('--shadow-hover', `0 8px 24px ${primary}26`);
    }, [primary, primaryLight, secondary, warning]);

    const theme = useMemo(() => {
        return createAppTheme(primary, secondary, warning);
    }, [primary, secondary, warning]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline enableColorScheme />
            {children}
        </ThemeProvider>
    );
}
